<div #printDoc class="pdf-hidden">
  <div class="pdf-content">
    <table width="100%" cellpadding="0" cellspacing="0">
      <tr valign="top">
        <td width="30%" style="border: none; padding: 0in">
          <p
            align="left"
            style="
              font-size: 10pt;
              text-align: center;
              padding: 0;
              margin: 0;
            "
          >
            {{ selectedDocument?.providerOrganization }}
          </p>
          <p
            align="left"
            style="
              font-size: 12pt;
              text-align: center;
              padding: 0;
              margin: 0;
            "
          >
            {{ selectedDocument?.providerAddress }}
          </p>
          <p
            align="left"
            style="
              font-size: 12pt;
              text-align: center;
              padding: 0;
              margin: 0;
            "
          >
            ĐT: <b>{{ selectedDocument?.providerPhone}}</b>
          </p>
          <p
            align="left"
            style="text-align: center; padding: 0; margin: 0"
          >
            ..................................<br />
          </p>
        </td>
        <td style="border: none; padding: 0in">
          <p class="pdf-title">TÓM TẮT HỒ SƠ</p>
          <p class="pdf-subtitle">(Medical Summary Report)</p>
        </td>
      </tr>
    </table>
    <p style="margin-top: 0.1in">&nbsp;</p>
    <p class="pdf-paragraph">
      <span class="pdf-label">Họ và tên / Full name:</span> {{ selectedDocument?.fullName }} &nbsp;&nbsp;&nbsp;
      <span class="pdf-label">Năm sinh / Năm sinh:</span> {{ selectedDocument?.birthYear }} &nbsp;&nbsp;&nbsp;
      <span class="pdf-label">Giới / Sex:</span> {{ selectedDocument?.gender }}
    </p>
    <p class="pdf-paragraph">
      <span class="pdf-label">Địa chỉ / Address:</span> {{ selectedDocument?.address }}
    </p>
    <p class="pdf-paragraph">
      <span class="pdf-label">Chẩn đoán / Diagnosis:</span> {{ selectedDocument?.diagnosis }}
    </p>
    <p class="pdf-paragraph pdf-label">Tóm tắt bệnh án / Summary:</p>
    
    <p class="pdf-section">
      a) Quá trình bệnh lý và diễn biến lâm sàng / History:<br><br>
      <span class="pdf-label">Tiền sử / Medical history:</span> {{ selectedDocument?.underlying }}<br><br>
      <span class="pdf-label">Diễn biến / Progress:</span>
    </p>
    <ul>
      <li *ngFor="let historyItem of selectedDocument?.history">{{ historyItem }}</li>
    </ul>
    
    <p class="pdf-section">
      b) Tóm tắt kết quả cận lâm sàng / Investigations:
    </p>
    <ul>
      <li *ngFor="let labItem of selectedDocument?.lab">{{ labItem }}</li>
    </ul>
    
    <p class="pdf-section">
      c) Phương pháp điều trị / Treatments:
    </p>
    <ul>
      <li *ngFor="let guideItem of selectedDocument?.guide">{{ guideItem }}</li>
    </ul>
    
    <p class="pdf-section pdf-label">Đơn thuốc / Medications:</p>
    <ol>
      <li *ngFor="let medication of selectedDocument?.medications">
        <b>{{ medication.brandName }}</b> – S.lượng: {{ medication.quantity }} – {{ medication.use }}
      </li>
    </ol>
    
    <p class="pdf-section">
      <span class="pdf-label">Ghi chú / Note:</span> {{ selectedDocument?.remark }}
    </p>
    
    <table width="100%">
      <tr>
        <td width="50%" style="text-align: center;">
          <span class="pdf-label">Ngày khám / Date:</span> {{ formattedCreatedAt }}
        </td>
        <td width="50%" style="text-align: center;">
          <br><br><br>
          <b>{{selectedDocument?.providerName}}</b>
        </td>
      </tr>
    </table>
  </div>
</div>
